import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook to scroll window to top on route navigation.
 * Web-specific: Uses browser's window.scrollTo API.
 * For React Native, this would need a platform-specific implementation.
 *
 * This ensures that when navigating between pages, the scroll position
 * resets to the top instead of maintaining the previous page's scroll position.
 */
export const useScrollToTop = (): void => {
  const location = useLocation();

  useEffect(() => {
    // Scroll to top immediately when pathname changes
    window.scrollTo(0, 0);
  }, [location.pathname]);
};
